/** PostHog `flow` and `recordPatientTermsAcceptance` deviceInfo.appVersion (PDF metadata). */
export const ONBOARDING_FLOW_LABEL = 'physiofit_services_web_onboarding' as const;
export const ONBOARDING_APP_VERSION_LABEL = ONBOARDING_FLOW_LABEL;
